import { zRequiredString } from "@goodfill/domain-properties-zod-validators";
import { hasOnlyAsciiChars } from "@goodfill/string";
import { atom } from "recoil";
import z from "zod";
import { zRequiredPhone } from "../../../form/zod/formPhone";
import { zPassword } from "../../../form/zod/password";
import { zRequiredEmail } from "../../../form/zod/zodTypes";

export const validSignUpFromState = atom<ValidSignUpFromStateType | null>({
  key: "customer-application-step1",
  default: null,
});

export const signUpFromStateSchema = z
  .object({
    firstName: zRequiredString()
      .max(18, { message: "max characters 18" })
      .refine(hasOnlyAsciiChars, { message: "only English chars" }),
    lastName: zRequiredString()
      .max(50, { message: "max characters 50" })
      .refine(hasOnlyAsciiChars, { message: "only English chars" }),
    phone1: zRequiredPhone,
    email: zRequiredEmail,
    password: zPassword,
    passwordConfirmation: zPassword,
  })
  .refine((val) => val.password === val.passwordConfirmation, {
    path: ["passwordConfirmation"],
    message: "passwords does not match",
  });

export type ValidSignUpFromStateType = z.infer<typeof signUpFromStateSchema>;
